import { render, staticRenderFns } from "./CompanySettingsPage.vue?vue&type=template&id=19878533&scoped=true"
import script from "./CompanySettingsPage.vue?vue&type=script&lang=js"
export * from "./CompanySettingsPage.vue?vue&type=script&lang=js"
import style0 from "./CompanySettingsPage.vue?vue&type=style&index=0&id=19878533&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19878533",
  null
  
)

export default component.exports